import { IApplicationState } from '../../types/redux';

export function getNewbuildingIdForSalesStartOnboarding(state: IApplicationState): number | null {
  return state.salesStartOnboarding.newbuildingId;
}
